import React from "react";
import { Link } from "react-router-dom";
import { MDBBtn } from "mdbreact";
import { scrollTop } from "../../../functions";

import "./HowToHelp.css";

export default () => {
  return (
    <div
      className="
      how-to-help 
      d-flex 
      justify-content-center 
      align-items-center 
      flex-column
      py-5"
    >
      <h1>Precisamos do seu apoio</h1>
      <p>Ajude-nos a ajudar os outros</p>
      <div className="hthelp-btns">
        <Link to="/como-ajudar/doacao" onClick={scrollTop}>
          <MDBBtn color="success">FAÇA UMA DOAÇÃO</MDBBtn>
        </Link>
        <Link to="/como-ajudar/servicos-voluntarios" onClick={scrollTop}>
          <MDBBtn color="success">TRABALHOS VOLUNTÁRIOS</MDBBtn>
        </Link>
      </div>
    </div>
  );
};
